module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-form-radio-group', {
    staticClass: "exclude-toggle",
    attrs: {
      "checked": _vm.value,
      "size": "sm",
      "buttons": ""
    },
    on: {
      "change": function($event) {
        _vm.$emit('input', $event)
      }
    }
  }, [_c('b-form-radio', {
    attrs: {
      "value": false,
      "button-variant": !_vm.value ? 'success' : null
    }
  }, [_vm._v("aftrekken van")]), _vm._v(" "), _c('b-form-radio', {
    attrs: {
      "value": true,
      "button-variant": _vm.value ? 'success' : null
    }
  }, [_vm._v("optellen bij")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a400798","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/ExcludeToggle.vue
// module id = 687
// module chunks = 1